import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Account, Session, UserRoles} from '../../domain/models';
import {PreferencesService} from '../../services/preferences/preferences.service';
import {OpenbandService} from "../../services/openband/openband.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss']
})
export class BurgerMenuComponent implements OnInit {
  isOpen = false;
  currentRoute: string = '';
  isFullScreen = false;
  userRole: UserRoles;
  eventId: string = '';
  account: Account = new Account();

  pageTitle: string = 'Default Title';

  private updatePageTitle(): void {
    const route = this.currentRoute;
    if (route === '/') {
      this.pageTitle = 'Expo';
    } else if (route == '/events') {
      this.pageTitle = 'Мероприятия';
    } else if (route.startsWith('/events') && route.includes('/participants')) {
      this.pageTitle = 'Участники';
    } else if (route.includes('/tag-bib')) {
      this.pageTitle = 'Tag-Bib';
    } else if (route.startsWith('/logs')) {
      this.pageTitle = 'Логи';
    } else if (route.includes('/mass-assignment')) {
      this.pageTitle = 'Массовое присвоение';
    } else if (route.includes('/users')) {
      this.pageTitle = 'Пользователи';
    } else {
      this.pageTitle = 'Expo';
    }
  }

  constructor(
    private router: Router,
    private prefs: PreferencesService,
    private api: OpenbandService,
    private modalService: NgbModal,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.parseRouteParams(event.url);
        this.updatePageTitle();
      }
    });
  }

  loadAccount() {
    this.api.getAccountSettings().subscribe(
      res => {
        this.account = res
      },
      error => {
        var old = this.prefs.appPreferences
        if (old?.sessions == null) old.sessions = []
        old.sessions = old.sessions.filter(x=> x.token == old.token)
        this.prefs.setAppPreferences(old)
      }
    )
  }

  getSelectedAccountName() : string {
    return this.account.username
  }

  ngOnInit(): void {
    this.loadAccount()
    this.sessions = this.prefs.appPreferences.sessions
  }

  private parseRouteParams(url: string): void {
    const params = url.split('/');
    if (params.length > 2) {
      this.eventId = params[2];
    }
  }

  toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }

  closeMenu(): void {
    this.isOpen = false;
  }

  toggleFullScreen(): void {
    if (!this.isFullScreen) {
      this.openFullScreen();
    } else {
      this.closeFullScreen();
    }
    this.closeMenu();
  }

  private openFullScreen(): void {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
      this.isFullScreen = true;
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen();
      this.isFullScreen = true;
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen();
      this.isFullScreen = true;
    }
  }

  private closeFullScreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      this.isFullScreen = false;
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
      this.isFullScreen = false;
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
      this.isFullScreen = false;
    }
  }

  navigate(route: string): void {
    this.router.navigate([route]);
    this.closeMenu();
  }

  isAdmin() {
    return this.account.role == UserRoles.admin || this.account.role == UserRoles.super_admin
  }

  isSuperAdmin(): boolean {
    return this.userRole === UserRoles.super_admin;
  }

  openCreateEventDialog(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
  }

  isAccountSwitcherOpen = false;
  sessions: Session[] = []; // список сессий
  currentSession: Session | null = null;

  toggleAccountSwitcher() {
    this.isAccountSwitcherOpen = !this.isAccountSwitcherOpen;
  }

  switchSession(session: Session) {
    var old = this.prefs.appPreferences
    old.token = session.token
    this.prefs.setAppPreferences(old)
    this.currentSession = session;
    this.isAccountSwitcherOpen = false;
    this.loadAccount()
  }

  addAccount() {
    this.isAccountSwitcherOpen = false;
    var token = prompt("Введите токен")
    var old = this.prefs.appPreferences
    if (old?.sessions == null) old.sessions = []
    let newSession = new Session(token)
    old.sessions.push(newSession)
    this.prefs.setAppPreferences(old)
  }

  getSessionName(session: Session) {
    let sessionName = session?.userData?.username
    if (sessionName == null) sessionName = "Unknown"
    return sessionName
  }
}
